@if (content) {
<div class="_container pos-relative">
    <df-image-wrapper class="fill">
        <img [ratio]="16/9"
             [dfImage]="content.image"
             [fill]="true">
    </df-image-wrapper>
    <div class="fill z-2"
         [style.background-color]="'rgba( ' + (content.darkContrast ? '0, 0, 0' : '255, 255, 255') + ', ' + content.overlayOpacity + ')'"
         [style.backdrop-filter]="'blur(' + (content.blur ? '1px' : '0px') + ')'">
    </div>
    <div class="pos-absolute left-0 right-0 bottom-10 z-3 p-r p-l flex-column flex-middle center"
         [ngClass]="content.darkContrast ? 'col-w' : 'col-1'"
         style="min-height: 275px;">
        <p *iCms="'title' of content; content: 'html'"
           class="h3"></p>
        <a class="button m-t-12 block"
           [routerLink]="'/login'">
            <span *iCms="'loginButtonText' of content"></span>
        </a>
        <a class="button-inline-2 m-t-5 block"
           [class._white]="content.darkContrast"
           [routerLink]="prevUrl">
            <span *iCms="'skipButtonText' of content"></span>
        </a>
    </div>
</div>
}
